<template>
  <div>
    <Pill
      v-if="shouldShowExpirationStatus"
      :class="{
        [$style.pillError]: isCertExpired,
        [$style.pillWarning]: isCertAboutToExpire,
      }"
      :text="expirationText"
    />
  </div>
</template>

<script>
import DateUtil from 'client/util/DateUtil';
import Pill from 'client/components/Buttons/Pill.vue';

export default {
  name: 'ApplicationExpiration',

  components: {
    Pill,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
  },

  computed: {
    expirationDate() {
      return this.item.sso.idpCertExpirationAt ? this.item.sso.idpCertExpirationAt : '';
    },

    expirationText() {
      return this.isCertExpired ? 'Expired' : `Expires ${this.handleDateFormat(this.expirationDate)}`;
    },

    isCertAboutToExpire() {
      return !this.isCertExpired && DateUtil.daysUntil(this.expirationDate) <= 61;
    },

    isCertExpired() {
      return DateUtil.hasExpired(this.expirationDate);
    },

    shouldShowExpirationStatus() {
      return !!this.item.sso.idpCertExpirationAt;
    },
  },

  methods: {
    handleDateFormat(expirationDate) {
      return DateUtil.formatDate(expirationDate);
    },
  },
};
</script>

<style module>
@value (jcError100, jcWarning100) from '~css/brand-colors.css';

.pillWarning {
  background-color: jcWarning100;
}

.pillError {
  background-color: jcError100;
}

</style>
